import AuthService from '@/common/services/auth.service';

export const IsNotAuthGuard = (to, from, next) => {
  if (AuthService.isAuthenticated()) {
    const role = AuthService.role();
    if (role === AuthService.ROLES.STUDENT || role === AuthService.ROLES.STUDENT_ONLY) {
      return next('/student');
    } else {
      return next('/admin');
    }
  }

  return next();
};
